module.exports = __webpack_public_path__ + "static/media/selec-nft-3.bc360d6a.png";